import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

// Only a build with the front door on (lib/frontDoor/flag.ts) has this page; any other build sends /landing to sign-in.
const LandingPage =
  import.meta.env.VITE_FRONT_DOOR === 'true'
    ? lazyRouteComponent(() => import('../components/FrontDoor/LandingPage'), 'LandingPage')
    : null

export const Route = createFileRoute('/landing')({
  beforeLoad: () => {
    if (!LandingPage) throw redirect({ to: '/login' })
  },
  component: LandingPage ?? (() => null),
})
